(() => {
  const root = document.querySelector("[data-hq-product]");

  if (!root || root.dataset.hqReady === "true") return;
  root.dataset.hqReady = "true";

  const form = root.querySelector("[data-hq-product-form]");
  const variantInput = root.querySelector("[data-hq-variant-id]");
  const variantChoices = Array.from(root.querySelectorAll("[data-hq-variant]"));
  const quantityInput = root.querySelector("[data-hq-quantity]");
  const addButton = root.querySelector("[data-hq-add]");
  const addLabel = root.querySelector("[data-hq-add-label]");
  const status = root.querySelector("[data-hq-form-status]");
  const price = root.querySelector("[data-hq-price]");
  const comparePrice = root.querySelector("[data-hq-compare-price]");
  const mainImage = root.querySelector("[data-hq-main-image]");
  const thumbnails = Array.from(root.querySelectorAll("[data-hq-thumbnail]"));

  function setStatus(message = "", isError = false) {
    if (!status) return;
    status.textContent = message;
    status.classList.toggle("is-error", isError);
  }

  function setMainImage(source, srcset, alt) {
    if (!mainImage || !source) return;
    mainImage.src = source;
    if (srcset) mainImage.srcset = srcset;
    if (alt) mainImage.alt = alt;
  }

  const preloadedImages = new Set();

  function preloadImage(thumbnail) {
    const source = thumbnail?.dataset.image;
    if (!source || preloadedImages.has(source)) return;
    preloadedImages.add(source);

    const image = new Image();
    image.decoding = "async";
    if (thumbnail.dataset.srcset && mainImage) {
      image.sizes = mainImage.sizes;
      image.srcset = thumbnail.dataset.srcset;
    }
    image.src = source;
  }

  function scheduleGalleryPreload() {
    thumbnails.forEach((thumbnail, index) => {
      window.setTimeout(() => preloadImage(thumbnail), 120 * index);
    });
  }

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(scheduleGalleryPreload, { timeout: 1200 });
  } else {
    window.setTimeout(scheduleGalleryPreload, 250);
  }

  function selectVariant(input, updateUrl = true) {
    if (!input || input.disabled || !variantInput) return;
    variantInput.value = input.value;
    setStatus();

    if (price && input.dataset.price) price.textContent = input.dataset.price;

    if (comparePrice) {
      const showCompare = input.dataset.compareVisible === "true";
      comparePrice.hidden = !showCompare;
      if (showCompare && input.dataset.compare) {
        comparePrice.textContent = input.dataset.compare;
      }
    }

    if (addButton && addLabel) {
      const available = input.dataset.available === "true";
      addButton.disabled = !available;
      addLabel.textContent = available ? "Add to cart" : "Sold out";
    }

    if (input.dataset.image) {
      setMainImage(input.dataset.image, input.dataset.srcset, "");
    }

    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", input.value);
      window.history.replaceState({}, "", url);
    }
  }

  variantChoices.forEach((input) => {
    input.addEventListener("change", () => selectVariant(input));
  });

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("pointerenter", () => preloadImage(thumbnail), {
      once: true,
    });
    thumbnail.addEventListener("focus", () => preloadImage(thumbnail), {
      once: true,
    });
    thumbnail.addEventListener("click", () => {
      thumbnails.forEach((item) => {
        item.classList.toggle("is-active", item === thumbnail);
        item.setAttribute(
          "aria-pressed",
          String(item === thumbnail),
        );
      });
      setMainImage(
        thumbnail.dataset.image,
        thumbnail.dataset.srcset,
        thumbnail.dataset.alt,
      );
    });
  });

  root.querySelector("[data-hq-quantity-minus]")?.addEventListener("click", () => {
    if (!quantityInput) return;
    quantityInput.value = String(
      Math.max(1, Number.parseInt(quantityInput.value, 10) - 1 || 1),
    );
  });

  root.querySelector("[data-hq-quantity-plus]")?.addEventListener("click", () => {
    if (!quantityInput) return;
    quantityInput.value = String(
      Math.max(1, Number.parseInt(quantityInput.value, 10) + 1 || 2),
    );
  });

  quantityInput?.addEventListener("change", () => {
    quantityInput.value = String(
      Math.max(1, Number.parseInt(quantityInput.value, 10) || 1),
    );
  });

  form?.addEventListener("submit", async (event) => {
    if (!variantInput || !quantityInput || !addButton) return;
    event.preventDefault();
    setStatus();
    addButton.disabled = true;
    const originalLabel = addLabel?.textContent || "Add to cart";
    if (addLabel) addLabel.textContent = "Adding...";

    try {
      const rootPath = window.Shopify?.routes?.root || "/";
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantInput.value),
              quantity: Math.max(1, Number.parseInt(quantityInput.value, 10) || 1),
            },
          ],
        }),
      });
      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || result.message || "Could not add this item.");
      }

      addButton.classList.add("is-added");
      if (addLabel) addLabel.textContent = "Added to cart";
      setStatus("Added to your cart.");
      document.dispatchEvent(new CustomEvent("cart:updated"));

      window.setTimeout(() => {
        addButton.classList.remove("is-added");
        if (addLabel) addLabel.textContent = originalLabel;
        addButton.disabled = false;
      }, 1800);
    } catch (error) {
      setStatus(error.message || "Could not add this item.", true);
      if (addLabel) addLabel.textContent = originalLabel;
      addButton.disabled = false;
    }
  });
})();
